export default {
    openPicker: () => Promise.reject('Not implemented for web'),
    openCamera: () => Promise.reject('Not implemented for web'),
  };